export default __webpack_public_path__ + "static/media/back-login-arrow.3fa2a2e1.svg";